var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcKiosksetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/40px/Display"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35 0H5C2.24404 0 0 2.24199 0 5V21C0 23.758 2.24404 26 5 26H19V30H8C7.44805 30 7 30.448 7 31C7 31.552 7.44805 32 8 32H32C32.552 32 33 31.552 33 31C33 30.448 32.552 30 32 30H21V26H35C37.756 26 40 23.758 40 21V5C40 2.24199 37.756 0 35 0ZM38 21C38 22.654 36.654 24 35 24H5C3.346 24 2 22.654 2 21V5C2 3.346 3.346 2 5 2H35C36.654 2 38 3.346 38 5V21Z",
    fill: "#3C5BD2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKiosksetting);
export default __webpack_public_path__ + "static/media/ic_kiosksetting.c28317f6986b4b72341ba190a2258446.svg";
export { ForwardRef as ReactComponent };